// extracted by mini-css-extract-plugin
export default {"noMatchFound":"style_noMatchFound__qLZia"};